import { IonButtons, IonContent, IonHeader, IonIcon, IonMenuButton, IonPage, IonTitle, IonToolbar } from "@ionic/react";
import { Link, useParams, useLocation } from "react-router-dom";
import UserBook from './UserBook'
import PrevPage from '@/components/PrevPage'

//const name = "Your Documents"
const UserBookPage: React.FC = () => {
    const { repo_id, id } = useParams<{ repo_id: string, id: string }>();
    const name = id;

    return (
        <IonPage>
            <IonHeader>
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonMenuButton />
                    </IonButtons>
                    <IonTitle>{name}</IonTitle>
                    <IonButtons slot="end">
                    </IonButtons>
                </IonToolbar>
            </IonHeader>

            <IonContent fullscreen>
                <IonHeader collapse="condense">
                    <IonToolbar>
                        <IonTitle size="large">{name}</IonTitle>
                    </IonToolbar>
                </IonHeader>
            <UserBook repo_id={repo_id} id={id} />
            </IonContent>
        </IonPage>
    )
}

export default UserBookPage;
